import filter from './assets/icons/filter.svg';
import retry from './assets/icons/retry.svg';

import next from './assets/icons/next.svg';
import previous from './assets/icons/previous.svg';
import spinner from '../assets/icons/spinner.svg';

import speedSlow from './assets/icons/speed-slow.svg';
import speedNormal from './assets/icons/speed-normal.svg';
import speedFaster from './assets/icons/speed-faster.svg';
import speedFastest from './assets/icons/speed-fastest.svg';

import rss from '../assets/icons/rss.svg';
import loading from '../assets/icons/state-loading.svg';
import waiting from '../assets/icons/state-waiting.svg';
import playing from '../assets/icons/state-playing.svg';
import paused from '../assets/icons/state-paused.svg';
import error from '../assets/icons/state-error.svg';
import adPlaying from '../assets/icons/state-adplaying.svg';
import adLoading from '../assets/icons/state-adloading.svg';

import backward from './assets/icons/backward.svg';
import forward from './assets/icons/forward.svg';
import download from '../assets/icons/download.svg';
import volumeHigh from './assets/icons/volume-high.svg';
import volumeMedium from './assets/icons/volume.svg';
import volumeLow from './assets/icons/volume-low.svg';
import volumeOff from './assets/icons/volume-off.svg';
import qualityLow from './assets/icons/quality-ld.svg';
import qualityMedium from './assets/icons/quality-md.svg';
import qualityHigh from './assets/icons/quality-hd.svg';
import share from '../assets/icons/share.svg';
import details from './assets/icons/details.svg';
import externalLink from './assets/icons/external-link.svg';

import facebook from './assets/icons/facebook.svg';
import twitter from './assets/icons/x.svg';
import whatsApp from './assets/icons/whatsapp.svg';
import linkedIn from './assets/icons/linkedin.svg';
import bluesky from './assets/icons/bluesky.svg';
import email from './assets/icons/email.svg';

import chevronUp from './assets/icons/chevron-up.svg';
import chevronDown from './assets/icons/chevron-down.svg';
import explicit from './assets/icons/explicit.svg';
import favicon from '../assets/favicon.svg';
import logo from '../assets/logo.svg';

export default {
  icons: {
    backward,
    forward,
    download,
    volumeHigh,
    volumeMedium,
    volumeLow,
    volumeDown: volumeLow,
    volumeUp: volumeHigh,
    volumeOff,
    qualityHigh,
    qualityMedium,
    qualityLow,
    next,
    previous,
    spinner,
    explicit,

    filter,
    retry,
    chevronUp,
    chevronDown,

    share,
    subscribe: rss,
    details,
    externalLink,

    speedSlow,
    speedNormal,
    speedFaster,
    speedFastest,

    error,
    loading,
    waiting,
    playing,
    paused,
    adPlaying,
    adLoading,

    facebook,
    twitter,
    whatsApp,
    linkedIn,
    bluesky,
    email
  },
  favicon: favicon,
  logo: logo
};
